import { DownOutlined } from '@ant-design/icons';
import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant';
import { ColumnTitles } from '../constants/column-titles.constant';
import { statusPreparation } from '../constants/status.constant';
import CustomDropdown from '../../../../v2-components/Antd/Dropdown';

export const dropdownOptionsStatus = (status, items) => {
	if (statusPreparation[Enviroment.LANGUAGE][status] !== undefined) {
		return (
			<CustomDropdown menu={{ items }} trigger={['click']}>
				<span style={{ cursor: 'pointer' }}>
					{ColumnTitles[Enviroment.LANGUAGE].status}
					<DownOutlined />
				</span>
			</CustomDropdown>
		);
	}
	return ColumnTitles[Enviroment.LANGUAGE].status;
};
